module.exports = __webpack_public_path__ + "img/3.aa63f242.jpg";